import moment from "moment"
import {
    SET_CHAT_USERS,
    SET_FILTER_DATA,
    SET_CURRENT_USER,
    SET_CONTACT_USERS,
    SET_AI_CHAT_PROMPT,
    SET_AI_CHAT_REDIRECT,
    SET_CONVERSATION_DATA,
    SEND_NEW_CHAT_MESSAGE,
    SEND_NEW_MEDIA_MESSAGE,
    SET_AI_CHAT_EXPORT_EXCEL,
    SET_AI_CHAT_CONTEXT_FILE,
    SET_AI_CHAT_LOCALIZATION,
    TOGGLE_SIDEBAR_COLLAPSED,
    SET_AI_CHAT_PROMPT_RESPONSE,
    SET_AI_CHAT_CONTEXT_DATASET,
    UPDATE_AI_CHAT_USER_SETTINGS
} from "../../@jumbo/constants/ActionTypes"

const INIT_STATE = {
    users: [],
    contacts: [],
    conversation: [],
    currentUser: null,
    currentPrompt: null,
    isSideBarCollapsed: false,
    filterData: {
        search: ""
    },
    localization: null,
    contextDataset: "",
    contextFile: "",

    // This value works when a File is selected on the Data Transfer / File Transfer page to be Enriched by AI
    // Button: AI Verrijken file
    redirect: null,  // {"folder": "", "file": "", "messageType": "", "messageText": ""}
    promptResponse: 0,
    userSettings: null,
    exportExcel: false
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SET_AI_CHAT_PROMPT_RESPONSE: {
            return {...state, promptResponse: action.payload}
        }

        case SET_AI_CHAT_PROMPT: {
            return {...state, currentPrompt: action.payload}
        }

        case SET_AI_CHAT_REDIRECT: {
            return {...state, redirect: action.payload}
        }

        case SET_AI_CHAT_CONTEXT_DATASET: {
            return {...state, contextDataset: action.payload}
        }

        case SET_AI_CHAT_CONTEXT_FILE: {
            return {...state, contextFile: action.payload}
        }

        case SET_AI_CHAT_LOCALIZATION: {
            return {...state, localization: action.payload}
        }

        case SET_CHAT_USERS: {
            return {...state, users: action.payload}
        }

        case SET_CONTACT_USERS: {
            return {...state, contacts: action.payload}
        }

        case SET_CURRENT_USER: {
            return {...state, currentUser: action.payload}
        }

        case SET_CONVERSATION_DATA: {
            return {...state, conversation: action.payload}
        }

        case UPDATE_AI_CHAT_USER_SETTINGS: {
            return {...state, userSettings: action.payload}
        }

        case SET_AI_CHAT_EXPORT_EXCEL: {
            return {...state, exportExcel: action.payload}
        }

        case SEND_NEW_CHAT_MESSAGE: {
            return {
                ...state,
                conversation: state.conversation.concat({
                    id: new Date().getTime(),
                    user: state.currentUser,
                    message: action.payload,
                    type: "sent",
                    messageType: "text",
                    sentAt: moment()
                })
            }
        }

        case SEND_NEW_MEDIA_MESSAGE: {
            return {
                ...state,
                conversation: state.conversation.concat({
                    id: new Date().getTime(),
                    user: state.currentUser,
                    type: "sent",
                    messageType: "media",
                    message: "kand",
                    media: action.payload,
                    sentAt: moment()
                })
            }
        }

        case SET_FILTER_DATA: {
            return {...state, filterData: {...state.filterData, ...action.payload}}
        }

        case TOGGLE_SIDEBAR_COLLAPSED: {
            return {...state, isSideBarCollapsed: !state.isSideBarCollapsed}
        }

        default:
            return state
    }
}
